import React from 'react';
import PropTypes from 'prop-types';
import { Col, KeyValue, NoValue, Row } from '@folio/stripes-components';
import Barcode from 'react-barcode';
import { ClipCopy } from '@folio/stripes/smart-components';
import css from '../../styles.css';

function BarcodeFieldView({ fieldValues, locale, data }) {
  const { name, label } = fieldValues;
  const fieldLabel = label.find((field) => field.locale === locale)?.value;

  return (
    <Row>
      <Col xs={6}>
        <KeyValue
          label={
            <>
              {fieldLabel}
              <ClipCopy text={data[name]} />
            </>
          }
          value={data[name] ? <Barcode value={data[name]} /> : <NoValue />}
        />
      </Col>
    </Row>
  );
}

BarcodeFieldView.propTypes = {
  fieldValues: PropTypes.object,
  locale: PropTypes.string,
  data: PropTypes.object,
};

export default BarcodeFieldView;
